// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"615bff3269952744b48c","303":"5c6b2ed6be49d3bc2c1e","495":"a4c8155a47e9b5262607"}[chunkId] + ".js";
};